import { z } from 'zod';

export const CHANGE_TYPE = {
  UPDATE: 'update',
  REPLACE: 'replace',
  INSERT: 'insert',
} as const;

export const CHANGE_SET_TYPE = {
  ADDED: 'added',
  DELETED: 'deleted',
  MODIFIED: 'modified',
} as const;

export const COLLECTIONS = {
  Criteria: 'Criteria',
  SupplierTemplate: 'SupplierTemplate',
  BrandTemplate: 'BrandTemplate',
  SettingTemplate: 'SettingTemplate',
  VehicleGroupType: 'VehicleGroupType',
  AutomakerGroup: 'AutomakerGroup',
  Country: 'Country',
  Entity: 'Entity',
  User: 'User',
} as const;

const IChangeSet = z.object({
  path: z.string(),
  type: z.enum(CHANGE_SET_TYPE),
  oldValue: z.unknown().nullish(),
  newValue: z.unknown().nullish(),
  value: z.unknown().nullish(),
});

export const baseChangeLog = z.object({
  id: z.string(),
  documentId: z.string(),
  db: z.string(),
  name: z.string(),
  type: z.enum(CHANGE_TYPE),
  collection: z.enum(COLLECTIONS),
  changeSet: z.array(IChangeSet),
  loggedAt: z.string(),
});
